module.exports = __webpack_public_path__ + "assets/img/img319.c7b01eae.png";